<template>
  <div class="w-100 my-1">
    <p>{{ questionDetails.questionInfo.questionText }}</p>
    <div class="d-flex align-items-center" style="gap: 2rem">
      <b-form-radio
        @change="handleCorrectExam"
        :name="`answer-${questionDetails.examQuestionId}`"
        class="custom-control-primary"
        :value="true"
      >
        <span class="text-success"> درست </span>
      </b-form-radio>
      <b-form-radio
        @change="handleCorrectExam"
        :name="`answer-${questionDetails.examQuestionId}`"
        class="custom-control-primary"
        :value="false"
      >
        <span class="text-danger"> نادرست </span>
      </b-form-radio>
    </div>
  </div>
</template>

<script>
export default {
  emits: ["getAnswer"],
  props: {
    questionDetails: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    handleCorrectExam(val) {
      this.$emit("getAnswer", this.questionDetails.questionId, val);
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormRadio,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BModal,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
  },
};
import {
  BCard,
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormRadio,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BModal,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
</script>
